// src/components/assets/AssetsMobileView.tsx
import React from 'react';
import { Edit, Trash2, Search, RefreshCw } from 'lucide-react';
import { AssetData } from '../../pages/Assets'; // Adjust path
import Pagination from '../shared/Pagination';

interface AssetsMobileViewProps {
  paginatedData: AssetData[];
  apiLoading: boolean;
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleEdit: (asset: AssetData) => void;
  handleDelete: (id: string) => void;
  getLabel: (group: string, value: string) => string;
  formatCurrency: (value: string | number) => string;
  formatDate: (date: string) => string;
   // Pagination Props
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  startIndex: number;
  endIndex: number;
  handlePageChange: (page: number) => void;
  handleItemsPerPageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const AssetCard: React.FC<Omit<AssetsMobileViewProps, 'paginatedData' | 'apiLoading' | 'searchTerm' | 'onSearchChange' | 'currentPage' | 'totalPages' | 'totalItems' | 'itemsPerPage' | 'startIndex' | 'endIndex' | 'handlePageChange' | 'handleItemsPerPageChange'> & { asset: AssetData }> = ({
    asset, handleEdit, handleDelete, getLabel, formatCurrency, formatDate
}) => (
    <div key={asset.id} className="bg-white rounded-lg p-3 shadow border border-gray-200 hover:shadow-md transition-all duration-200 flex flex-col">
        <div className="flex justify-between items-start mb-2">
            <div></div>
            <div className="flex space-x-1">
                <div className="space-y-1 text-xs text-green-600 text-left"><div className="text-green-800 font-bold truncate"> {getLabel('assetType', asset.assetType) || 'Asset'}</div></div>
                <button onClick={() => handleEdit(asset)} className="p-1 text-green-600 hover:bg-green-50 rounded transition-colors"><Edit className="w-4 h-4" /></button>
                <button onClick={() => handleDelete(asset.id)} className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors"><Trash2 className="w-4 h-4" /></button>
            </div>
        </div>
        <div className="mb-2"><p className="text-base font-bold text-green-600 text-center truncate">{asset.assetCurrentPrice && formatCurrency(parseFloat(asset.assetCurrentPrice))}</p></div>
        <div className="space-y-1 text-xs text-gray-600 text-center">
            {asset.assetSubType && (<div className="text-gray-800 font-medium truncate"> {getLabel('assetSubType', asset.assetSubType)}</div>)}
            <div className="text-gray-800 font-medium">{asset.assetspurchaseDate ? formatDate(asset.assetspurchaseDate) : 'N/A'}</div>
            <div className="text-gray-800 font-medium truncate">{asset.assetUnitPrice && formatCurrency(parseFloat(asset.assetUnitPrice))}</div>
        </div>
    </div>
);

const AssetsMobileView: React.FC<AssetsMobileViewProps> = (props) => {
    const { paginatedData, apiLoading, searchTerm, onSearchChange, ...rest } = props;

    return (
        <div className="md:hidden">
            <div className="p-2">
                <div className="relative max-w-md mx-auto mb-4">
                    <input type="text" placeholder="Search asset records..." value={searchTerm} onChange={onSearchChange} className="w-full p-2 pl-10 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600" />
                    <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                </div>
            </div>

            {apiLoading ? (
                <div className="text-center py-12 flex justify-center items-center">
                    <RefreshCw className="w-6 h-6 animate-spin text-green-600" /><span className="ml-2">Loading Assets...</span>
                </div>
            ) : (
                <div className="grid grid-cols-2 sm:grid-cols-2 gap-4 max-w-full px-2">
                    {paginatedData.map((asset) => (
                        <AssetCard key={asset.id} asset={asset} {...rest} />
                    ))}
                </div>
            )}
             {props.totalItems > props.itemsPerPage && !apiLoading && (
                <Pagination {...props} isMobile />
             )}
        </div>
    );
};

export default AssetsMobileView;